import Button from '@lyra/core/components/Button'
import { OrderQuoteParams } from '@lyra/web/constants/order'
import TradeFormModal from '@lyra/web/containers/trade/TradeFormModal'
import { formatInstrument } from '@lyra/web/utils/instruments'
import { getDefaultOrderQuoteParams } from '@lyra/web/utils/order'
import React, { useState } from 'react'
import { useMemo } from 'react'

type Props = {
  instrumentName: string
  isLong: boolean
  size: number
}

export default function PositionCloseButton({ instrumentName, isLong, size }: Props) {
  const [isOpen, setIsOpen] = useState(false)

  const order: OrderQuoteParams = useMemo(
    () => ({
      ...getDefaultOrderQuoteParams(instrumentName),
      instrument_name: instrumentName,
      direction: isLong ? 'sell' : 'buy',
      amount: size.toString(),
    }),
    [instrumentName, isLong, size]
  )

  return (
    <>
      <Button label="Close" onPress={() => setIsOpen(true)} />
      {isOpen ? (
        <TradeFormModal
          order={order}
          onClose={() => setIsOpen(false)}
          onSubmitOrder={() => setIsOpen(false)}
          title="Close Position"
          subtitle={formatInstrument(instrumentName, { showExpiry: true })}
          hideBuySellToggle
          disableTriggers
        />
      ) : null}
    </>
  )
}
